import { render, staticRenderFns } from "./CtcSettings.vue?vue&type=template&id=02f1be5c&scoped=true"
import script from "./CtcSettings.vue?vue&type=script&lang=js"
export * from "./CtcSettings.vue?vue&type=script&lang=js"
import style0 from "./CtcSettings.vue?vue&type=style&index=0&id=02f1be5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f1be5c",
  null
  
)

export default component.exports